/*
 * SonarQube
 * Copyright (C) 2009-2024 SonarSource SA
 * mailto:info AT sonarsource DOT com
 *
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with this program; if not, write to the Free Software Foundation,
 * Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 */
.projects-page .layout-page-header-panel-inner,
.projects-page .layout-page-header-panel {
  height: 98px;
  line-height: normal;
}

.projects-topbar-item + .projects-topbar-item {
  padding-left: 24px;
}

.projects-topbar-item .spinner {
  top: -1px;
}

.projects-topbar-item.is-last {
  margin-left: auto;
  padding-left: 32px;
}

.projects-topbar-item-search {
  position: relative;
  flex: 1;
  height: 24px;
}

.projects-header-row {
  padding-top: 2px;
}

.projects-list .page-actions {
  margin-bottom: 0;
}

.project-card-name {
  font-weight: 600;
}

.projects-leak-sorting-option.is-focused {
  background-color: #f1e8cb;
}

.projects-facet-list {
  padding-left: 10px;
  padding-right: 10px;
}

.projects-facets-header {
  margin-bottom: 10px;
  padding: 10px 0;
  border-bottom: 1px solid #e6e6e6;
}

.projects-facets-reset {
  float: right;
}

.projects-facet-bar {
  display: inline-block;
  width: 60px;
  margin-left: 8px;
}

.projects-facet-bar-inner {
  min-width: 1px;
  height: 10px;
  background-color: #888;
  transition: width 0.3s ease;
}

.projects-empty-list {
  padding: 32px 0;
  text-align: center;
}

/***
  Custom filter highlights.
  Projects filters are special, as some elements allow the selection of "everything
  worse than" filters (e.g., "Rating B or worse"). We still select a single element,
  but we want to give a visual indication that we selected multiple fitlers.
  That's where the following selectors come in, which extend and override styles
  from ../../components/search-navigator.css
***/

/*
  Completely remove the border of the child facet. Handle them at the parent
  <li> level.
*/
.search-navigator-facet-worse-than-highlight .search-navigator-facet {
  border: 0 !important;
}

.search-navigator-facet-worse-than-highlight {
  padding: 1px 0;
  border-width: 0 1px;
  border-color: transparent;
  border-style: solid;
  box-sizing: border-box;
}

/*
  When:
  - Being hovered
  - Or, being a sibling of something hovered
  - Or, being active
  - Or, being a sibling of something active
  show the left and right borders.
*/
.search-navigator-facet-worse-than-highlight:hover,
.search-navigator-facet-worse-than-highlight:hover ~ .search-navigator-facet-worse-than-highlight,
.search-navigator-facet-worse-than-highlight.active,
.search-navigator-facet-worse-than-highlight.active ~ .search-navigator-facet-worse-than-highlight {
  border-left-color: #4b9fd5;
  border-right-color: #4b9fd5;
}

/*
  When:
  - Being hovered
  - Or, being active
  show the top border, and remove the top padding.
*/
.search-navigator-facet-worse-than-highlight:hover,
.search-navigator-facet-worse-than-highlight.active {
  border-top: 1px solid #4b9fd5 !important;
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
  padding-top: 0 !important;
}

/*
  When:
  - Being hovered AND the last element of the highlightable group
  - Or, being the last element of the highlightable group AND a sibling of something hovered
  - Or, being active AND the last element of the highlightable group
  - Or, being the last element of the highlightable group AND a sibling of something active
  show the bottom border, and remove the bottom padding.
*/
.search-navigator-facet-worse-than-highlight.last:hover,
.search-navigator-facet-worse-than-highlight:hover
  ~ .search-navigator-facet-worse-than-highlight.last,
.search-navigator-facet-worse-than-highlight.active.last,
.search-navigator-facet-worse-than-highlight.active
  ~ .search-navigator-facet-worse-than-highlight.last {
  border-bottom: 1px solid #4b9fd5 !important;
  border-bottom-left-radius: 2px;
  border-bottom-right-radius: 2px;
  padding-bottom: 0 !important;
}

/*
  When:
  - Being active
  - Or, being a sibling of something active
  show a light blue background color.
*/
.search-navigator-facet-worse-than-highlight.active,
.search-navigator-facet-worse-than-highlight.active ~ .search-navigator-facet-worse-than-highlight {
  background-color: #f2faff;
}

/*
  When:
  - Being hovered AND a sibling of something active
  - Or, being a sibling of something hovered AND a sibling of something active
  show a darker blue background color.
*/
.search-navigator-facet-worse-than-highlight.active
  ~ .search-navigator-facet-worse-than-highlight:hover,
.search-navigator-facet-worse-than-highlight.active
  ~ .search-navigator-facet-worse-than-highlight:hover
  ~ .search-navigator-facet-worse-than-highlight {
  background-color: #a1cde8;
}

.project-filters-list {
  /*
   * On Firefox on Windows, the scrollbar hides the sidebar's content.
   * Using 'scrollbar-gutter:stable' is a workaround to ensure consistency with other browsers.
   * @see https://bugzilla.mozilla.org/show_bug.cgi?id=764076
   */
  scrollbar-gutter: stable;
}
